export { default } from './CategoriesTaxonomy'
